<div class="header">
  Block: {{ formGroup.value.entryType | questionnaireEntryType }}
  <button mat-icon-button type="button" (click)="toggleExpansion()">
    <mat-icon [@expandCollapseIndicator]="expanded">expand_more</mat-icon>
  </button>
</div>

<div class="body-wrapper" [@boxExpanded]="expanded">
  <mat-divider></mat-divider>

  <div class="body" [formGroup]="formGroup">
    <mat-form-field>
      <mat-label i18n>Blocktyp</mat-label>
      <mat-select formControlName="entryType" (valueChange)="changeEntryType.emit($event)">
        @for (entryType of entryTypes; track entryType) {
          <mat-option [value]="entryType">{{ entryType | questionnaireEntryType }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (formGroup.value.entryType === 'textBlock') {
      <mat-form-field>
        <mat-label i18n>Schriftstil</mat-label>
        <mat-select formControlName="type">
          <mat-option value="body" i18n>Haupttext</mat-option>
          <mat-option value="caption" i18n>Subtext</mat-option>
        </mat-select>
        <mat-hint i18n>Beeinflusst Größe und Farbe</mat-hint>
      </mat-form-field>
      <div class="line-break"></div>
      <mat-form-field class="growing-field">
        <mat-label i18n>Anzuzeigender Text</mat-label>
        <textarea matInput formControlName="text"></textarea>
        <mat-error i18n>Der Text darf nicht leer sein</mat-error>
      </mat-form-field>
    }

    @if (isTextQuestionForm(formGroup)) {
      <mat-form-field class="growing-field">
        <mat-label i18n>Frage</mat-label>
        <input matInput formControlName="question" />
        <mat-hint i18n>Optional</mat-hint>
      </mat-form-field>
      <div class="line-break"></div>
      <mat-form-field>
        <mat-label i18n>Beschriftung</mat-label>
        <input matInput formControlName="label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Minimale Länge</mat-label>
        <input matInput type="number" formControlName="minLength" />
        <mat-hint i18n>Optional</mat-hint>
        @if (formGroup.controls.minLength.errors?.min) {
          <mat-error i18n>Die Länge muss positiv sein</mat-error>
        }
        @if (formGroup.controls.minLength.errors?.pattern) {
          <mat-error i18n>Nur Ganzzahlen sind erlaubt</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Maximale Länge</mat-label>
        <input matInput type="number" formControlName="maxLength" />
        <mat-hint i18n>Optional</mat-hint>
        @if (formGroup.controls.maxLength.errors?.min) {
          <mat-error i18n>Die Länge muss positiv sein</mat-error>
        }
        @if (formGroup.controls.maxLength.errors?.minMaxCollapsed) {
          <mat-error i18n>Der Wert liegt unter dem Minimum</mat-error>
        }
        @if (formGroup.controls.maxLength.errors?.pattern) {
          <mat-error i18n>Nur Ganzzahlen sind erlaubt</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Regulärer Ausdruck</mat-label>
        <input matInput formControlName="pattern" />
        <button mat-icon-button type="button" matSuffix [dtHoverPopover]="regexExplanationPopover"><mat-icon>info</mat-icon></button>
        <mat-hint i18n>Optional</mat-hint>
        <mat-error i18n>Kein gültiger regulärer Ausdruck</mat-error>
      </mat-form-field>
    }

    @if (isNumberQuestionForm(formGroup)) {
      <mat-form-field class="growing-field">
        <mat-label i18n>Frage</mat-label>
        <input matInput formControlName="question" />
        <mat-hint i18n>Optional</mat-hint>
      </mat-form-field>
      <div class="line-break"></div>
      <mat-form-field>
        <mat-label i18n>Beschriftung</mat-label>
        <input matInput formControlName="label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Minimum</mat-label>
        <input matInput type="number" formControlName="min" />
        <mat-hint i18n>Optional</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Maximum</mat-label>
        <input matInput type="number" formControlName="max" />
        <mat-hint i18n>Optional</mat-hint>
        <mat-error i18n>Der Wert liegt unter dem Minimum</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Schrittweite</mat-label>
        <input matInput type="number" formControlName="step" />
        <mat-hint i18n>Optional</mat-hint>
      </mat-form-field>
    }

    @if (isOptionsQuestionForm(formGroup)) {
      <mat-form-field class="growing-field">
        <mat-label i18n>Frage</mat-label>
        <input matInput formControlName="question" />
        <mat-hint i18n>Optional</mat-hint>
      </mat-form-field>
      <div class="line-break"></div>
      <mat-form-field>
        <mat-label i18n>Anzeigetyp</mat-label>
        <mat-select formControlName="displayType">
          <mat-option value="dropdown" i18n>Dropdown</mat-option>
          <mat-option value="radio" i18n>Radio-Buttons</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Beschriftung</mat-label>
        <input matInput formControlName="label" />
      </mat-form-field>
      <div class="line-break"></div>
      <ng-container formArrayName="options">
        @for (option of formGroup.controls.options.controls; track option; let optionIndex = $index) {
          <mat-form-field>
            <mat-label i18n>Option {{ optionIndex + 1 }}</mat-label>
            <input matInput [formControlName]="optionIndex" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              [disabled]="formGroup.disabled || formGroup.controls.options.length <= 1"
              (click)="deleteOption(optionIndex)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-form-field>
        }
      </ng-container>
      <button mat-button type="button" [disabled]="formGroup.disabled" (click)="addOption()">
        <mat-icon>add</mat-icon><ng-container i18n>Option hinzufügen</ng-container>
      </button>
    }

    @if (isTableQuestionForm(formGroup)) {
      <mat-form-field class="growing-field">
        <mat-label i18n>Basisfrage</mat-label>
        <input matInput formControlName="baseQuestion" />
        <mat-hint i18n>Wird in der Tabellenüberschrift angezeigt</mat-hint>
      </mat-form-field>
      <div class="line-break"></div>
      <ng-container formArrayName="subQuestions">
        @for (option of formGroup.controls.subQuestions.controls; track option; let subQuestionIndex = $index) {
          <mat-form-field>
            <mat-label i18n>Unterfrage {{ subQuestionIndex + 1 }}</mat-label>
            <input matInput [formControlName]="subQuestionIndex" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              [disabled]="formGroup.disabled || formGroup.controls.subQuestions.length <= 1"
              (click)="deleteSubQuestion(subQuestionIndex)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-form-field>
        }
      </ng-container>
      <button mat-button type="button" [disabled]="formGroup.disabled" (click)="addSubQuestion()">
        <mat-icon>add</mat-icon><ng-container i18n>Unterfrage hinzufügen</ng-container>
      </button>
      <div class="line-break"></div>
      <ng-container formArrayName="options">
        @for (option of formGroup.controls.options.controls; track option; let optionIndex = $index) {
          <mat-form-field>
            <mat-label i18n>Option {{ optionIndex + 1 }}</mat-label>
            <input matInput [formControlName]="optionIndex" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              [disabled]="formGroup.disabled || formGroup.controls.options.length <= 1"
              (click)="deleteOption(optionIndex)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-form-field>
        }
      </ng-container>
      <button mat-button type="button" [disabled]="formGroup.disabled" (click)="addOption()">
        <mat-icon>add</mat-icon><ng-container i18n>Option hinzufügen</ng-container>
      </button>
    }

    <button matRipple class="delete-button" type="button" [disabled]="formGroup.disabled" (click)="delete.emit()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>

<ng-template #regexExplanationPopover>
  <div class="regex-explanation-popover mat-elevation-z8" i18n
    >Reguläre Ausdrücke erlauben es die zulässigen Zeichenketten einzuschränken. Weitere Informationen findest Du auf
    <a href="https://de.wikipedia.org/wiki/Regul%C3%A4rer_Ausdruck" target="_blank" rel="noopener noreferrer">Wikipedia</a>
    oder in den
    <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions" target="_blank" rel="noopener noreferrer"
      >MDN Webdocs</a
    >.</div
  >
</ng-template>
